import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderUserPreferences: build.query<
      GetV2ProviderUserPreferencesApiResponse,
      GetV2ProviderUserPreferencesApiArg
    >({
      query: () => ({ url: `/v2/provider/user-preferences` }),
    }),
    putV2ProviderUserPreferences: build.mutation<
      PutV2ProviderUserPreferencesApiResponse,
      PutV2ProviderUserPreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/user-preferences`,
        method: "PUT",
        body: queryArg.updateUserPreferencesRequest,
      }),
    }),
    getV2ProviderUserPreferencesSuggestedActions: build.query<
      GetV2ProviderUserPreferencesSuggestedActionsApiResponse,
      GetV2ProviderUserPreferencesSuggestedActionsApiArg
    >({
      query: () => ({ url: `/v2/provider/user-preferences/suggested-actions` }),
    }),
    getV2ProviderUserPreferencesSuggestedActionsRegistry: build.query<
      GetV2ProviderUserPreferencesSuggestedActionsRegistryApiResponse,
      GetV2ProviderUserPreferencesSuggestedActionsRegistryApiArg
    >({
      query: () => ({
        url: `/v2/provider/user-preferences/suggested-actions/registry`,
      }),
    }),
    putV2ProviderUserPreferencesSuggestedActionsByActionId: build.mutation<
      PutV2ProviderUserPreferencesSuggestedActionsByActionIdApiResponse,
      PutV2ProviderUserPreferencesSuggestedActionsByActionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/user-preferences/suggested-actions/${queryArg.actionId}`,
        method: "PUT",
        body: queryArg.updateSuggestedActionPreferenceRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderUserPreferencesApiResponse =
  /** status 200 OK */ GetUserPreferencesResponse;
export type GetV2ProviderUserPreferencesApiArg = void;
export type PutV2ProviderUserPreferencesApiResponse =
  /** status 200 OK */ UpdateUserPreferencesResponse;
export type PutV2ProviderUserPreferencesApiArg = {
  updateUserPreferencesRequest: UpdateUserPreferencesRequest;
};
export type GetV2ProviderUserPreferencesSuggestedActionsApiResponse =
  /** status 200 OK */ GetSuggestedActionsResponse;
export type GetV2ProviderUserPreferencesSuggestedActionsApiArg = void;
export type GetV2ProviderUserPreferencesSuggestedActionsRegistryApiResponse =
  /** status 200 OK */ GetActionDefinitionsResponse;
export type GetV2ProviderUserPreferencesSuggestedActionsRegistryApiArg = void;
export type PutV2ProviderUserPreferencesSuggestedActionsByActionIdApiResponse =
  /** status 200 OK */ UpdateSuggestedActionPreferenceResponse;
export type PutV2ProviderUserPreferencesSuggestedActionsByActionIdApiArg = {
  actionId: string;
  updateSuggestedActionPreferenceRequest: UpdateSuggestedActionPreferenceRequest;
};
export type CopyPastePreferences = {
  html_formatting_on_copy?: boolean;
  include_header_on_copy_multiple?: boolean;
};
export type CustomDocumentPrompt = {
  created_at: string;
  description?: string | null;
  document_type: string;
  name: string;
  prompt: string;
  prompt_id: string;
  updated_at?: string | null;
};
export type CustomLabBundle = {
  bundle_id: string;
  created_at: string;
  description?: string | null;
  name: string;
  special_instructions?: string | null;
  test_names: string[];
  updated_at?: string | null;
};
export type DocumentPreferences = {
  letterhead_md_string?: string | null;
};
export type JotCoachPreferences = {
  minimum_nudge_minutes?: number | null;
};
export type WebRecordingPreferences = {
  stop_mode?: string | null;
};
export type RecordingPreferences = {
  redact_names?: boolean;
  web_recording?: WebRecordingPreferences | null;
};
export type SuggestedActionPreference = {
  enabled?: boolean;
  updated_at?: string | null;
  version?: number | null;
};
export type UserPreferences = {
  copy_paste_preferences?: CopyPastePreferences | null;
  custom_document_prompts?: CustomDocumentPrompt[] | null;
  custom_lab_bundles?: CustomLabBundle[] | null;
  document_preferences?: DocumentPreferences | null;
  jotcoach_preferences?: JotCoachPreferences | null;
  recording_preferences?: RecordingPreferences | null;
  subject?: string | null;
  suggested_action_preferences?: {
    [key: string]: SuggestedActionPreference;
  } | null;
};
export type GetUserPreferencesResponse = {
  message: string;
  preferences: UserPreferences;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type CopyPastePreferences2 = {
  html_formatting_on_copy?: boolean;
  include_header_on_copy_multiple?: boolean;
};
export type CustomDocumentPrompt2 = {
  created_at: string;
  description?: string | null;
  document_type: string;
  name: string;
  prompt: string;
  prompt_id: string;
  updated_at?: string | null;
};
export type CustomLabBundle2 = {
  bundle_id: string;
  created_at: string;
  description?: string | null;
  name: string;
  special_instructions?: string | null;
  test_names: string[];
  updated_at?: string | null;
};
export type DocumentPreferences2 = {
  letterhead_md_string?: string | null;
};
export type JotCoachPreferences2 = {
  minimum_nudge_minutes?: number | null;
};
export type WebRecordingPreferences2 = {
  stop_mode?: string | null;
};
export type RecordingPreferences2 = {
  redact_names?: boolean;
  web_recording?: WebRecordingPreferences2 | null;
};
export type SuggestedActionPreference2 = {
  enabled?: boolean;
  updated_at?: string | null;
  version?: number | null;
};
export type UserPreferences2 = {
  copy_paste_preferences?: CopyPastePreferences2 | null;
  custom_document_prompts?: CustomDocumentPrompt2[] | null;
  custom_lab_bundles?: CustomLabBundle2[] | null;
  document_preferences?: DocumentPreferences2 | null;
  jotcoach_preferences?: JotCoachPreferences2 | null;
  recording_preferences?: RecordingPreferences2 | null;
  subject?: string | null;
  suggested_action_preferences?: {
    [key: string]: SuggestedActionPreference2;
  } | null;
};
export type UpdateUserPreferencesResponse = {
  message: string;
  preferences: UserPreferences2;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type CopyPastePreferences3 = {
  html_formatting_on_copy?: boolean;
  include_header_on_copy_multiple?: boolean;
};
export type DocumentPreferences3 = {
  letterhead_md_string?: string | null;
};
export type WebRecordingPreferences3 = {
  stop_mode?: string | null;
};
export type RecordingPreferences3 = {
  redact_names?: boolean;
  web_recording?: WebRecordingPreferences3 | null;
};
export type SuggestedActionPreference3 = {
  enabled?: boolean;
  updated_at?: string | null;
  version?: number | null;
};
export type UpdateUserPreferencesRequest = {
  copy_paste_preferences?: CopyPastePreferences3 | null;
  document_preferences?: DocumentPreferences3 | null;
  recording_preferences?: RecordingPreferences3 | null;
  subject?: string | null;
  suggested_action_preferences?: {
    [key: string]: SuggestedActionPreference3;
  } | null;
};
export type SuggestedActionPreference4 = {
  enabled?: boolean;
  updated_at?: string | null;
  version?: number | null;
};
export type GetSuggestedActionsResponse = {
  message: string;
  suggested_actions: {
    [key: string]: SuggestedActionPreference4;
  } | null;
};
export type ActionDefinition = {
  action_id: string;
  default_enabled: boolean;
  description: string;
  display_name: string;
  version: number;
};
export type GetActionDefinitionsResponse = {
  actions: {
    [key: string]: ActionDefinition;
  };
  message: string;
};
export type UpdateSuggestedActionPreferenceResponse = {
  action_type: string;
  enabled: boolean;
  message: string;
};
export type UpdateSuggestedActionPreferenceRequest = {
  enabled?: boolean | null;
};
